<template>
  <div class="top-div">
    <Loading v-if="$auth0.isLoading.value" title="Getting Users..." />
    <UserListContent :users="users" @ban-toggle="handleBanToggle" />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useAdminApi } from "@/plugins/api";
import UserListContent from "../../components/UserListContent.vue";
const $adminApi = useAdminApi();
const users = ref([]);
const loading = ref(false);
async function handleBanToggle(updatedUser) {
  try {
    await $adminApi.putSoftBanUser(updatedUser.id, updatedUser.is_soft_banned);
  } catch (error) {
    console.error("Error updating user ban status:", error);
  }
}
onMounted(async () => {
  try {
    loading.value = true;
    users.value = await $adminApi.getUsersByDealerId();
  } catch (error) {
    console.error("Error fetching users:", error);
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
.top-div {
  margin-top: 6rem;
  padding: var(--padding);
}
</style>
